import React, { useState } from "react";
import "./PriceBreakup.scss";
import Tooltip from "../Tooltip";

// SVG assets
const imgCaretDown = "/assets/images/caret-down.svg";
const imgInfoIconPriceBreakup = "/assets/images/info-icon-pricebreakup.svg";
const imgRupeeIcon = "/assets/images/rupee-icon.svg";
const imgPaymentCompleted = "/assets/images/payment-completed-button.svg";

const PriceBreakup = ({ 
  bookingDetails = {}, 
  onSamagriPayment, 
  onFullPayment, 
  isExpanded: externalIsExpanded,
  onToggle,
  bookingStatus,
  remainingAmount = 0,
  isPaymentCompleted = false,
  isSamagriPaid,
}) => {
  const [internalIsExpanded, setInternalIsExpanded] = useState(false);
console.log(isSamagriPaid, "isSamagriPaid")
  // Use external isExpanded if provided, otherwise use internal state
  const isExpanded =
    externalIsExpanded !== undefined ? externalIsExpanded : internalIsExpanded;

  // Use external onToggle if provided, otherwise use internal setter
  const setIsExpanded = onToggle || setInternalIsExpanded;

  // Calculate samagri cost from booking data (default samagri only - Karishye only)
  const samagriCost =
    bookingDetails?.bookingSamagriMappings?.reduce((total, item) => {
      if (item.samagriType === "default" && item.isProvidedBy === "karishye") {
        return total + (item.samagri?.customerMrp * item.qty || 0);
      }
      return total;
    }, 0) || 0;

  // Calculate add-on samagri cost (Karishye only)
  const addonSamagriCost =
    bookingDetails?.bookingSamagriMappings?.reduce((total, item) => {
      if (item.samagriType === "addon" && item.isProvidedBy === "karishye") {
        return total + (item.samagri?.customerMrp * item.qty || 0);
      }
      return total;
    }, 0) || 0;

  // Calculate total samagri cost (default + add-on)
  const totalSamagriCost = samagriCost + addonSamagriCost;

  // Get values from booking details
  const pujariCost = bookingDetails?.pujariCost || 0;
  const serviceFee = bookingDetails?.serviceFee || 0;
  const gst = bookingDetails?.gst || 0;
  const totalSellingPrice = bookingDetails?.bookingSellingPrice || 0;

  const priceItems = [
    {
      id: 1,
      description: `Pujari x${bookingDetails?.noOfPujaris || 0}`,
      amount: `₹ ${pujariCost.toFixed(2)}`,
    },
    {
      id: 2,
      description: "Samagri",
      amount: `₹ ${samagriCost.toFixed(2)}`,
    },
    {
      id: 3,
      description: "Add on Samagri",
      amount: `₹ ${addonSamagriCost.toFixed(2)}`,
    },
    {
      id: 4,
      description: "Service Charges applied",
      amount: `₹ ${serviceFee.toFixed(2)}`,
    },
    ...(gst > 0
      ? [
          {
            id: 5,
            description: "GST",
            amount: `₹ ${gst.toFixed(2)}`,
            hasIcon: true,
            tooltip:
              "By paying a little bit of taxes on your puja, you are indirectly doing a great service to the country and our pujari family. We thank you 🙏",
          },
        ]
      : []),
  ];

  const totalAmount = totalSellingPrice.toFixed(2);
  
  // Calculate the amount to display for payment
  const getPaymentAmount = () => {
    if (bookingStatus === "puja_confirmed" || bookingStatus === "puja_ended") {
      return remainingAmount.toFixed(2);
    }
    return totalAmount;
  };
  
  const paymentAmount = getPaymentAmount();

  return (
    <div className="price-breakup-container" data-node-id="8946:424">
      <div className="price-breakup-content sm:tw-p-[24px]">
        <div className="price-breakup-header" data-node-id="8946:425">
          <div className="price-breakup-title" data-node-id="8946:426">
            <p>Price Breakup</p>
          </div>
          <div
            className="price-breakup-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className={`caret-icon ${isExpanded ? "expanded" : ""}`}>
              <img alt="" src={imgCaretDown} />
            </div>
          </div>
        </div>

        {isExpanded && (
          <>
            <div
              className="price-breakup-table"
              data-name="Samagri Table listing"
              data-node-id="8946:430"
            >
              {/* Table Header */}
              <div className="table-header" data-node-id="8946:431">
                <div className="header-border" />
                <div className="header-content">
                  <div className="description-header" data-node-id="8946:432">
                    <div className="header-text" data-node-id="8946:433">
                      <p>Description</p>
                    </div>
                  </div>
                  <div className="amount-header" data-node-id="8946:434">
                    <div className="header-text" data-node-id="8946:435">
                      <p>Amount</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Rows */}
              {priceItems.map((item, index) => (
                <div
                  key={item.id}
                  className="table-row"
                  data-node-id={`8947:${993 + index}`}
                >
                  <div className="row-border" />
                  <div className="row-content">
                    <div
                      className="description-cell"
                      data-node-id={`8947:${994 + index}`}
                    >
                      {item.hasIcon ? (
                        <div className="text-icon-container">
                          <div
                            className="item-text"
                            data-node-id={`8947:${995 + index}`}
                          >
                            <p>{item.description}</p>
                          </div>
                          <Tooltip content={item.tooltip} position="top">
                            <div
                              className="info-icon"
                              role="button"
                              aria-label={item.tooltip}
                            >
                              <div className="icon-container">
                                <div className="icon-wrapper">
                                  <img
                                    alt="info"
                                    className="block max-w-none size-full"
                                    src={imgInfoIconPriceBreakup}
                                  />
                                </div>
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                      ) : (
                        <div
                          className="item-text"
                          data-node-id={`8947:${995 + index}`}
                        >
                          <p>{item.description}</p>
                        </div>
                      )}
                      {item.hasSubtext && (
                        <div
                          className="subtext-container"
                          data-node-id="8947:1011"
                        >
                          <div
                            className="subtext-content"
                            data-node-id="8947:1012"
                          >
                            <div
                              className="subtext-text"
                              data-node-id="8947:1013"
                            >
                              <p>{item.subtext}</p>
                            </div>
                            <div
                              className="subtext-icon"
                              data-name="icon"
                              data-node-id="8947:1014"
                            >
                              <div
                                className="icon-container"
                                data-node-id="8947:1015"
                              >
                                <div className="icon-wrapper">
                                  <img
                                    alt=""
                                    className="block max-w-none size-full"
                                    src={imgInfoIconPriceBreakup}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {item.hasLink && (
                            <div className="link-text" data-node-id="8947:1019">
                              <p>{item.linkText}</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div
                      className="amount-cell"
                      data-node-id={`8947:${1001 + index}`}
                    >
                      <div
                        className="amount-text"
                        data-node-id={`8947:${1002 + index}`}
                      >
                        <p>{item.amount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Total Row */}
              <div className="total-row" data-node-id="8946:470">
                <div className="total-content">
                  <div className="total-label" data-node-id="8946:471">
                    <div className="total-text" data-node-id="8946:472">
                      <p>Total Payable</p>
                    </div>
                  </div>
                  <div className="total-amount-row" data-node-id="8946:473">
                    <div className="rupee-icon" data-node-id="8946:474">
                      <img alt="" src={imgRupeeIcon} />
                    </div>
                    <div className="total-value" data-node-id="8946:478">
                      <p>{totalAmount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Options */}
            <div className="payment-options sm:tw-hidden">
              {isPaymentCompleted ? (
                <div className="payment-completed-option">
                  <div className="payment-completed-content">
                    <div className="payment-completed-icon">
                      <img alt="" src={imgPaymentCompleted} />
                    </div>
                    <div className="payment-completed-text">
                      <p>You don&apos;t have to worry anything now! You are all Paid!</p>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className={`full-payment-option ${(bookingStatus === "puja_confirmed" || bookingStatus === "puja_ended" || totalSamagriCost === 0 || (bookingStatus === "pujari_assigned" && isSamagriPaid)) ? "full-width" : ""}`} data-node-id="8946:480">
                    <div className="option-content">
                      <div
                        className="option-text"
                        data-node-id="8946:481"
                        onClick={() =>
                          onFullPayment && onFullPayment(parseFloat(paymentAmount))
                        }
                        style={{ cursor: onFullPayment ? "pointer" : "default" }}
                      >
                        <p>
                          <span>Pay {bookingStatus === "puja_confirmed" || bookingStatus === "puja_ended" ? "remaining" : "full"} amount (₹ </span>
                          <span className="bold">{paymentAmount}</span>
                          <span>)</span>
                        </p>
                      </div>
                    </div>
                    <div className="option-border" />
                  </div>
                  {bookingStatus !== "puja_confirmed" && bookingStatus !== "puja_ended" && totalSamagriCost > 0 && !(bookingStatus === "pujari_assigned" && isSamagriPaid) && (
                    <div className="samagri-payment-option" data-node-id="8946:482">
                      <div className="option-content">
                        <div
                          className="option-text"
                          data-node-id="8946:483"
                          onClick={() =>
                            onSamagriPayment && onSamagriPayment(totalSamagriCost)
                          }
                          style={{ cursor: onSamagriPayment ? "pointer" : "default" }}
                        >
                          <p>
                            Pay only for Samagri (₹ {totalSamagriCost.toFixed(2)})
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>
      <div className="container-border" />
    </div>
  );
};

export default PriceBreakup;
